import React, {Component} from 'react';
import './Salaryslip.css';
import moment from 'moment'
class  Salaryslip extends React.Component {
    constructor(props){
        super(props);
        this.state = {
           
            name:[],
            
          };
    }
    
    printData=()=>{
        var printContents = document.getElementById("print").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.href = "/portal";

    }
  render() {
      
        return <div className="blank">
            <div className="row " >
                <div className=" col-md-12 ">
                    <a href="#" type="button" onClick={(e)=>this.printData()} className="float-right m-5 mt-0"><b>Print</b><i className="fa fa-print ml-1"></i></a>
                </div>
            </div>
            <div id="print" className="salary-table">
                <div className="row col-md-12 mb-2">
                    <h5 className="text-center col-md-12">TIDINGS DIGITAL PUBLICATIONS PVT LTD</h5>
                    <h4 className="text-center col-md-12">Salary Slip</h4>
                
                </div>
            <div className="row col-md-12 mb-2 ">
               
                <table className="table table-bordered ">
                    <tbody>
                        <tr>
                            <td>Employee Name</td>
                            <td>{this.props.docData.employee_name}</td>
                            <td>Date of Joining</td>
                            <td>{this.props.docData.date_of_joining}</td>
                        </tr>
                        <tr>
                            <td>Employee No:</td>
                            <td>{this.props.docData.employee}</td>
                            <td>Date of Birth</td>
                            <td>{this.props.docData.date_of_birth}</td>
                        </tr>
                        <tr>
                            <td>Bank Name</td>
                            <td>{this.props.docData.bank_name}</td>
                            <td>Bank A/c No.</td>
                            <td>{this.props.docData.bank_account_no}</td>
                        </tr>
                        <tr>
                            <td>Pan No</td>
                            <td>{this.props.docData.pan_no ? this.props.docData.pan_no : <p>None</p>}</td>
                            <td>Post/Designation</td>
                            <td>{this.props.docData.designation}</td>
                        </tr>
                        <tr>
                          <td>Salary Date</td>
                          <td>{moment(this.props.docData.posting_date).format('DD-MMM-YYYY')}</td>
                          {/* <td>&nbsp;</td>
                          <td>&nbsp;</td> */}
                        </tr>
                       
                        <tr>
                          <td colspan="2" valign="top"><h6>Earnings</h6>
                        <table className="table align-middle mb-0 bg-white salaryslip-border">
                            <thead className="">
                                <tr>
                                    <th>Income</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                            {this.props.docData.earnings ?  this.props.docData.earnings.map((item,k)=>{
                               
                               return(
                                    <tr key={k}>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div className="ms-3">
                                                <p className="text-muted mb-0">{item.salary_component}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="text-muted mb-0">₹{item.amount}</p>
                                    </td>
                                </tr>
                                                     )
                                                        }):""} 
                                
                               <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div className="ms-3">
                                                <p className="text-muted mb-0">Total Earnings</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="text-muted mb-0">₹{this.props.docData.gross_pay}</p>
                                    </td>
                                </tr> 
                            </tbody>
                        </table></td>
                          <td colspan="2" align="left" valign="top"><h6>Deductions</h6>
                        <table className="table align-middle mb-0 bg-white salaryslip-border">
                            <thead className="">
                                <tr>
                                    <th>Deduction</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                            {this.props.docData.deductions ?  this.props.docData.deductions.map((itm,k)=>{
                             
                               return(
                                <tr key={k}>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div className="ms-3">
                                                <p className="text-muted mb-0">{itm.salary_component}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="text-muted mb-0">{itm.amount}</p>
                                    </td>
                                </tr>
                                 )
                                }):""} 

                      {this.props.docData.deductions ?  this.props.docData.earnings.map((itm,k)=>{
                        
                        let limit=this.props.docData.earnings.length-this.props.docData.deductions.length;
                             if (k<limit)
                             return(
                              <tr key={k}>
                                  <td>
                                      <div className="d-flex align-items-center">
                                          <div className="ms-3">
                                              <p className="text-muted mb-0">&nbsp;</p>
                                          </div>
                                      </div>
                                  </td>
                                  <td>
                                      <p className="text-muted mb-0">&nbsp;</p>
                                  </td>
                              </tr>
                               )
                              }):""} 

                               <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div className="ms-3">
                                                <p className="text-muted mb-0">Total Deductions</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="text-muted mb-0">{this.props.docData.total_deduction}</p>
                                    </td>
                                </tr> 
                               
                            </tbody>
                        </table>
                        </td>
                        
                        </tr>
                        <tr>
                          <td>Net Salary </td>
                          <td>₹{this.props.docData.base_net_pay}</td>
                          <td>Total in words</td>
                          <td>{this.props.docData.total_in_words}</td>
                        </tr>
                    </tbody>
                </table>
             
            </div>
        </div>
</div>
}
}
export default Salaryslip;